module.exports = __webpack_public_path__ + "static/media/Bear Territory_2c.38489933.svg";